module.exports = __webpack_public_path__ + "images/modeling-framework.jpg?v=f23348904936c0edac2ebf18ca54aabf";